import * as $ from 'jquery';

/**
 * FilterFormController
 *
 * @author Markus Hölzle <m.hoelzle@andersundsehr.com>
 * @author Thomas Schur <t.schur@andersundsehr.com>
 */
export default class FilterFormHash {
  private values = {};

  constructor() {
    this.values = {};
  }

  /**
   * @param {string} prefix
   * @param {jQuery} $formElements
   * @param {boolean} usePublicValues
   */
  addFormValues(prefix, $formElements, usePublicValues) {
    $formElements.each((index, element) => {
      const $input = $(element);
      let name = $input.attr('name');
      let value = $input.val();
      const isSelect = $input.filter('select').length > 0;
      const isCheckbox = $input.filter('input[type="checkbox"]').length > 0;
      const isMultiple = $input.filter('select[multiple],input[type="checkbox"]').length > 0;
      const isRadio = $input.filter('input[type="radio"]').length > 0;
      if (name) {
        if (isSelect) {
          if (value === '') {
            value = $input.find('option:selected').attr('value');
          }
          if (usePublicValues === true) {
            value = this.getPublicValueFromSelect(value, $input);
          }
        }
        if (isCheckbox) {
          if ($input[0].checked !== true) {
            value = '';
          } else if ($input.attr('data-url-value')) {
            value = $input.attr('data-url-value');
          }
        }
        if (isRadio) {
          if (!$input.prop('checked')) {
            value = '';
          } else if ($input.attr('data-url-value')) {
            value = $input.attr('data-url-value');
          }
        }

        if (value) {
          if ($input.attr('data-url-name')) {
            name = $input.attr('data-url-name');
          } else {
            name = this.getNameWithoutPrefix(name, prefix);
          }
          this.addValue(name, value, isMultiple);
        }
      }
    });
  }

  /**
   * @returns {string}
   */
  getHash() {
    let hash = '';
    for (let parameter in this.values) {
      if ({}.hasOwnProperty.call(this.values, parameter)) {
        let value = this.values[parameter];
        if (typeof value === 'object') {
          value = value.join();
        }
        hash = this.addParameterToString(hash, parameter, value, '&', '=');
      }
    }
    return hash;
  }

  /**
   * @returns {string}
   */
  getClassSelector() {
    let selector = '';
    for (let parameter in this.values) {
      if ({}.hasOwnProperty.call(this.values, parameter)) {
        let value = this.values[parameter];
        if (typeof value === 'object') {
          for (let singleValueIndex in value) {
            if ({}.hasOwnProperty.call(value, singleValueIndex)) {
              selector = this.addParameterToString(selector, '.' + parameter, value[singleValueIndex], '', '-');
            }
          }
        } else {
          selector = this.addParameterToString(selector, '.' + parameter, value, '', '-');
        }
      }
    }
    return selector;
  }

  /**
   * @param {string} hash
   * @param {jQuery} $formElements
   * @param {string} prefix
   */
  setFormFieldsFromHash(hash, $formElements, prefix) {
    const filterParts = decodeURI(hash).substring(1).split('&');

    $.each(filterParts, (index, filterPart) => {
      const keyValue = filterPart.split('=');
      const filter = '[name="' + prefix + '[' + keyValue[0] + ']"], [' + 'data-url-name' + '="' + keyValue[0] + '"]';
      const filterMultiple = '[name="' + prefix + '[' + keyValue[0] + '][]"]';
      const $input = $formElements.filter(filter);
      let value = keyValue[1];
      if (value) {
        value = value.replace('__', '&amp;');
        if ($input.length === 0) { // check checkbox
          const valueArray = value.split(',');
          const $possibleElements = $formElements.filter(filterMultiple);
          for (let i = 0; i < valueArray.length; i++) {
            let $checkbox = $possibleElements.filter('[value="' + valueArray[i] + '"]');
            if ($checkbox.length === 0) {
              $checkbox = $possibleElements.filter('[' + 'data-url-value' + '="' + valueArray[i] + '"]');
            }
            $checkbox.attr('checked', 'checked').change();
          }
        }
        if ($input.filter('select').length > 0) {
          $input.find('option').removeProp('selected').filter((indexInner) => {
            return indexInner.innerHTML === value || $(indexInner).attr('data-url-value') === value;
          }).prop('selected', 'selected');
          $input.change().trigger('chosen:updated');
        } else if ($input.filter('[type="radio"]').length > 0) {
          $input.prop('checked', false);
          $input.filter('[value="' + value + '"],[' + 'data-url-value' + '="' + value + '"]').prop('checked', true).change();
        } else {
          $input.val(value).change();
        }
      }
    });
  }

  /**
   * @param {string} value
   * @param {jQuery} $select
   * @returns {string}
   */
  getPublicValueFromSelect(value, $select) {
    let returnValue = value;
    if (value === '0') {
      returnValue = '';
    }
    if (value) {
      const $option = $select.find('option[value="' + value + '"]');
      returnValue = $option.attr('data-url-value');
      if (!returnValue) {
        returnValue = $option.html();
      }
    }
    return returnValue;
  }

  /**
   * @param {string} name
   * @param {string} prefix
   * @returns {string}
   */
  getNameWithoutPrefix(name, prefix) {
    let returnName = name.replace(prefix, ''); // remove prefix
    if (returnName.charAt(0) === '[') { // remove first char
      returnName = returnName.substr(1);
    }
    if (returnName.slice(-2) === '[]') { // remove last chars
      returnName = returnName.slice(0, -2);
    }
    if (returnName.slice(-1) === ']') { // remove last char
      returnName = returnName.slice(0, -1);
    }
    return returnName;
  }

  /**
   * @param {string} name
   * @param {string} value
   * @param {boolean} isMultiple
   */
  addValue(name, value, isMultiple) {
    const returnValue = value.replace(/&amp;/gi, '__');
    if (isMultiple === false) {
      this.values[name] = returnValue;
    } else {
      if (typeof this.values[name] === 'undefined') {
        this.values[name] = [];
      }
      this.values[name].push(returnValue);
    }
  }

  /**
   * @param {string} hash
   * @param {string} parameter
   * @param {string} value
   * @param {string} outerDelimiter
   * @param {string} innerDelimiter
   * @returns {string}
   */
  addParameterToString(hash, parameter, value, outerDelimiter, innerDelimiter) {
    let returnHash = hash;
    if (hash !== '') {
      returnHash += outerDelimiter;
    }
    return returnHash + parameter + innerDelimiter + value;
  }
}
